/** Currency codes → display symbol and Arabic label */
export const CURRENCIES = {
  SAR: { symbol: 'ر.س', label: 'ريال سعودي (SAR)' },
  IQD: { symbol: 'د.ع', label: 'دينار عراقي (IQD)' },
  SYP: { symbol: 'ل.س', label: 'ليرة سورية (SYP)' },
  EGP: { symbol: 'ج.م', label: 'جنيه مصري (EGP)' },
  AED: { symbol: 'د.إ', label: 'درهم إماراتي (AED)' },
  KWD: { symbol: 'د.ك', label: 'دينار كويتي (KWD)' },
  LYD: { symbol: 'د.ل', label: 'دينار ليبي (LYD)' },
  USD: { symbol: '$', label: 'دولار أمريكي (USD)' },
};

import { api } from '../api/client';

export function getCurrencySymbol(code) {
  return CURRENCIES[code]?.symbol || code || '';
}

export function getCurrencyLabel(code) {
  return CURRENCIES[code]?.label || code;
}

export const CURRENCY_CODES = Object.keys(CURRENCIES);

export async function fetchCurrencies() {
  try {
    return await api.getPublicCurrencies();
  } catch (e) {}
  return null;
}

export function buildCurrenciesMap(list) {
  if (!list || !list.length) return CURRENCIES;
  const map = {};
  for (const c of list) {
    if (!c.is_active) continue;
    map[c.code] = { symbol: c.symbol, label: `${c.name_ar} (${c.code})` };
  }
  return map;
}

export function buildCurrencyCodes(list) {
  if (!list || !list.length) return CURRENCY_CODES;
  return list.filter(c => c.is_active).map(c => c.code);
}
